function marioPPOLogo(size: number, theme: string, primary: string, dark: boolean) {
	return (
		<svg
			viewBox='0 0 25 25'
			className='circle-logo'
			aria-hidden={true}
		>
			<g transform='translate(2.5, 0.25)'>
				<rect
					width='1'
					height='1'
					x='7'
					y='4'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='4'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='4'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='4'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='4'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='5'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='6'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='7'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='8'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='9'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='10'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='11'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='11'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='11'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='11'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='11'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='11'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='12'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='12'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='12'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='4'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='13'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='13'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='13'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='13'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='13'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='4'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='14'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='14'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='14'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='14'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='14'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='4'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='15'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='15'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='4'
					y='16'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='16'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='9'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='10'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='16'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='16'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='16'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='8'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='11'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='17'
					fill={dark ? theme : primary}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='18'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='4'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='5'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='6'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='7'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='12'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='13'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='14'
					y='19'
					fill={dark ? primary : theme}
				></rect>
				<rect
					width='1'
					height='1'
					x='15'
					y='19'
					fill={dark ? primary : theme}
				></rect>
			</g>
		</svg>
	)
}

export default marioPPOLogo
